/*
 * Header drawer accordion.
 *
 * The navigation drawer nests each submenu inside its parent list item and
 * reveals it in place, rather than sliding a panel over the menu. Delegated
 * from the document so sections re-rendered by the theme editor keep working.
 */
(function () {
  'use strict';

  var TOGGLE = '.drawer-accordion__toggle';

  function setExpanded(button, expanded) {
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.hidden = !expanded;
  }

  function collapseDescendants(button) {
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;

    panel.querySelectorAll(TOGGLE).forEach(function (nested) {
      setExpanded(nested, false);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(TOGGLE);
    if (!button) return;

    event.preventDefault();

    var expanded = button.getAttribute('aria-expanded') === 'true';
    setExpanded(button, !expanded);

    // Closing a branch should not leave its children open behind it.
    if (expanded) collapseDescendants(button);
  });
})();
